var path = '/client/common/modules/abstract-picker/views/partials/abstract-picker-object.html';
var html = "<div class=\"abstract-picker-object\">\n    {{ ::object.id }}\n</div>\n";
window.angular.module('AppTemplates').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;